import axios from "axios";

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

//login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
const loginurl = process.env.REACT_APP_LOGIN_URL;

export const LoginRequest = (
  phone,
  otp,
  handleClick,
  handleErrOpen,
  
  ) => {
  return async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    try {
      axios.post(`${loginurl}/verify_finvesta_user_mobile_login`, { mobile_no: phone, otp: otp })
      .then((res) => {
        if (res.status == 200) {
          console.log("success");
          handleClick(true);
          dispatch(loginSuccess(res.data));
          
  
        } else {
          console.log("no otp");
          handleErrOpen();
        }
      });
    } catch (err) {
        console.log("error",err);
      handleErrOpen();
    }
  };
};

export const loginSuccess = (user) => (
  {

  type: LOGIN_SUCCESS,
  payload: user
}
);

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error
});


  